// extracted by mini-css-extract-plugin
export var categoryTile = "category-tile-module--category-tile--fOFkr";
export var description = "category-tile-module--description--GRP5d";
export var dots = "category-tile-module--dots--mkByS";
export var hidden = "category-tile-module--hidden--F35gv";
export var link = "category-tile-module--link--fZS0T";
export var title = "category-tile-module--title--NCLDX";